// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5909cb1e","609":"3c2a8e3e","625":"aaa7b35a","649":"a99571ee","652":"1cfe23c8","674":"ab11e89e","863":"11801239","872":"4743f816","900":"15d961ea"}[chunkId] + ".chunk.js";
};